<template>
    <div >
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'I18nUpdater',
  props: {
    i18nGroupName: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState('i18n', {
      'i18nLanguages': state => state.i18nLanguages
    })
  },
  beforeRouteUpdate (to, from, next) {
    if (this.i18nGroupName === '') {
      next()
      return
    }
    let test = false
    for (var i = 0; i < this.i18nLanguages.length; i++) {
      if (this.i18nLanguages[i].lang === to.params.lang) {
        test = true
      }
    }
    // si on a pas de lang dans l'addresse
    if (!test) {
      // this.$router.push('/' + this.$i18n.locale + '/404')
      this.$router.push('/' + this.$i18n.locale)
      this.loadLanguageJson()
    } else {
      // console.log('ici')
      this.$emit('i18nChangeState', true)
    }
    next()
  },
  mounted () {
    // console.log('I18nUpdater')
    this.loadLanguageJson()
  },
  methods: {
    loadLanguageJson () {
      this.$emit('i18nChangeState', false)
      this.$store.dispatch('i18n/loadLanguageGroup', { group: this.i18nGroupName, locale: this.$i18n.locale }).then(response => {
        this.$nextTick(this.onReady)
      })
    },
    onReady () {
      this.$emit('i18nChangeState', true)
    }
  }
}

</script>

<style>

</style>
